
<template>
  <div class="my-wrap" :class="{ 'member-menu-open': memberMenuOpen }">
    <div class="member-heading">
      <h1>{{ $t('Bao.shop') }}</h1>
    </div>
    <!-- 1100px 以下 nav-tabs 收合，由此按鈕展開（切版 member-center.js 的 member-menu-toggle） -->
    <button
      type="button"
      class="member-menu-toggle"
      aria-controls="shop-page-navigation"
      :aria-expanded="String(memberMenuOpen)"
      @click="memberMenuOpen = !memberMenuOpen"
    >
      {{ currentTabLabel }}
    </button>
    <ul id="shop-page-navigation" class="nav-tabs my-mall-exchange-tabs">
      <li :class="{ 'active': $route.path === '/points/all-bonus' }" @click="$router.push('/points/all-bonus')">
        <a>
          {{ $t('Bao.vip_type') }}
        </a>
      </li>
      <li :class="{ 'active': $route.path === '/points/coupon' }" @click="$router.push('/points/coupon')">
        <a>
          {{ $t('Bao.coupon') }}
        </a>
      </li>
    </ul>
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      memberMenuOpen: false
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    currentTabLabel() {
      return this.$route.path === '/points/coupon' ? this.$t('Bao.coupon') : this.$t('Bao.vip_type')
    }
  },
  watch: {
    // 切換分頁後收起手機選單
    '$route.path'() {
      this.memberMenuOpen = false
    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
